// extracted by mini-css-extract-plugin
module.exports = {"CartProduct":"CartProduct_CartProduct__3cVVl"};